




























import { RelatedTag } from '@empathy/search-types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { EVENTS } from '../../bus/events.const';
import { EmpathyXConfig } from '../../models';
import { GETTERS_KEYS, SUBMODULES_PATHS } from '../../store';

@Component({
  computed: {
    ...mapGetters({
      components: GETTERS_KEYS.config.components,
      config: GETTERS_KEYS.config.config
    }),
    ...mapState(SUBMODULES_PATHS.querySignals, ['relatedTags'])
  }
})
export default class RelatedTags extends Vue {
  private relatedTags: RelatedTag[];
  private config: EmpathyXConfig;

  get tagClickedEvent() {
    return this.config.relatedTags.selectable ? EVENTS.ToggleRelatedTag : EVENTS.ApplyRelatedTag;
  }

  get hasRelatedTags(): boolean {
    return this.relatedTags.length > 0;
  }
}
